import * as React from 'react'

const LocationBadgeBase = ({ children }: { children: React.ReactNode }) => (
  <div className="flex justify-center items-center text-sm">
    <div className="flex h-[38px] items-center justify-center bg-[#EEF6F8] text-[#6B9AAA] font-bold font-yu-gothic leading-none desktop:p-[4px_12px] sp:p-[8px]">
      {children}
    </div>
  </div>
)

export const LocationBadge3 = ({
  location,
}: {
  location?: { short_name: string; name: string }
}) => {
  return (
    <LocationBadgeBase>
      {location?.short_name || location?.name}
    </LocationBadgeBase>
  )
}
